module.exports = __webpack_public_path__ + "static/img/banner-carousel-20251211-154031.e90d5f9.png";